module.exports = __webpack_public_path__ + "static/Flavor_18AMT90229-0eb8bb124bf0cdbbe97e10a80669b0f6.pdf";